import React from 'react';
import { useParams, useLocation } from 'react-router-dom';

import {
    Heading,
    Tab,
    TabIndicator,
    TabList,
    TabPanel,
    TabPanels,
    Tabs
} from '@chakra-ui/react';

// tabs
import { MedicalReviews, Overview, Treatment } from './tabs';

export const RecordDetails = (): JSX.Element => {
    const { id } = useParams();
    const { state } = useLocation();

    return (
        <>
            <Heading as='h1' size='lg' noOfLines={1} ml={'1'} mb={'5'} >
                Historia
            </Heading>
            <Tabs isLazy>
                <TabList>
                    <Tab color={'primary.500'}>Detalles</Tab>
                    <Tab color={'primary.500'}>Revisiones</Tab>
                    <Tab color={'primary.500'}>Tratamiento</Tab>
                </TabList>
                <TabIndicator
                    mt="-1.5px"
                    height="2px"
                    bg="'primary.500'"
                    borderRadius="1px"
                />
                <TabPanels>
                    <TabPanel>
                        <Overview recordId={id} />
                    </TabPanel>
                    <TabPanel>
                        <MedicalReviews recordId={id} patientId={state.patientId} />
                    </TabPanel>
                    <TabPanel>
                        <Treatment recordId={id} />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </>
    );
};
